import React from 'react'
import LinkList from '../../components/LinkList'
import _ from 'lodash'

const LinkListWrapper = ({ entity }) => {
  const title = entity.fieldTitle;
  const items = _.get(entity, 'fieldLinks', []).map(link => ({
    name: link.title,
    url: link.url.path
  }))
  const className = _.get(entity, 'fieldClassName', '')

  return (
    <LinkList title={title} items={items} smallPadding={className === 'small-padding'} />
  )
}

export default LinkListWrapper
